import React from 'react'
import { connect } from 'react-redux'
import settings from 'settings'
import { Link, withRouter } from 'react-router-dom'

class AllTrainingMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  renderCoursesSubMenu() {
    if (this.props.match.path === '/all') {
      return this.props.content.courses.map((course, i) => {
        const className = (
          (this.props.activeTab === null && i === 0)
          || (this.props.activeTab === course.uuid)
        ) ? 'active' : ''
        return (
          <li
            className={className}
            key={course.uuid}
            style={{ paddingLeft: 15 }}
          >
            <a
              onClick={() => {
                this.props.onActiveTab(course.uuid)
              }}
              href={`#scroll-${i}`}
              data-uk-scroll="offset: 100"
            >
              {course.title}
            </a>
          </li>
        )
      })
    }
    return null
  }

  renderByVulnerabilityMenu() {
    if (this.props.match.path === '/by-vulnerability') {
      return this.props.vulnerabilities.map((vulnerabilityCategory, i) => {
        const className = (
          (this.props.activeTab === null && i === 0)
          || (this.props.activeTab === vulnerabilityCategory.id)
        ) ? 'active' : ''
        return (
          <React.Fragment key={vulnerabilityCategory.id}>
            <li
              className={`${className}`}
              key={vulnerabilityCategory.id}
              style={{ paddingLeft: 15, marginTop: i !== 0 ? 5 : 0, marginBottom: 0 }}
            >
              {vulnerabilityCategory.title}
            </li>
            {vulnerabilityCategory.vulnerabilities.map((vulnerability) => {
              return (
                <li
                  className={`${className} hover-text uk-margin-remove`}
                  key={vulnerability.id}
                  style={{ paddingLeft: 30, height: 32 }}
                >
                  <input
                    className="uk-checkbox"
                    type="checkbox"
                    checked={Boolean(this.props.vulnerabilityFilters[vulnerability.id])}
                    onChange={this.props.onToogleVulnerability.bind(this, vulnerability.id)}
                    style={{
                      width: 12,
                      height: 12,
                      backgroundSize: 'contain',
                      borderRadius: 4,
                      marginRight: 7,
                    }}
                  />

                  <a
                    onClick={this.props.onToogleVulnerability.bind(this, vulnerability.id)}
                    href={`#scroll-vuln-${vulnerability.id}`}
                    data-uk-scroll="offset: 100"
                    className={this.props.vulnerabilityFilters[vulnerability.id] ? 'uk-text-primary' : null}
                  >
                    <i>
                      {vulnerability.title}
                    </i>
                  </a>
                </li>
              )
            })}
          </React.Fragment>
        )
      })
    }
    return null
  }

  renderByCodeReviewMenu() {
    if (this.props.match.path === '/coding-challenges') {
      return this.props.content.map((language, i) => {
        const className = (
          (this.props.activeTab === null && i === 0)
          || (this.props.activeTab === i)
        ) ? 'active' : ''
        return (
          <li
            className={className}
            key={language.language_name}
            style={{ paddingLeft: 15 }}
          >
            <a
              onClick={() => {
                this.props.onActiveTab(i)
              }}
              href={`#scroll-code-rev-${i}`}
              data-uk-scroll="offset: 100"
            >
              {settings.engines[language.language_name]}
            </a>
          </li>
        )
      })
    }
    return null
  }

  render() {
    return (
      <ul className="links dark">
        <li className={this.props.match.path === '/all' ? 'active' : ''}>
          <Link to="/all">
            Courses
          </Link>
        </li>
        {this.renderCoursesSubMenu()}
        <li className={this.props.match.path === '/by-vulnerability' ? 'active' : ''}>
          <Link to="/by-vulnerability">
            Vulnerability Types
          </Link>
        </li>
        {this.renderByVulnerabilityMenu()}
        <li className={this.props.match.path === '/challenges' ? 'active' : ''} style={{ marginTop: this.props.match.path === '/by-vulnerability' ? 10 : null }}>
          <Link to="/challenges">
            Hacking Challenges
          </Link>
        </li>
        {this.props.showCodingChallenges && (
          <>
            <li className={this.props.match.path === '/coding-challenges' ? 'active' : ''}>
              <Link to="/coding-challenges">
                Coding Challenges
              </Link>
            </li>
          </>
        )}
      </ul>
    )
  }
}

const mapStateToProps = (state) => ({
  showCodingChallenges: state.hacker.showCodingChallenges,
})

export default withRouter(connect(mapStateToProps, {

})(AllTrainingMenu))
